// src/config.js
let CATEGORIES_COLOR = {
  ship: 'rgb(255, 157, 226)',
  aircraft: 'rgb(140, 130, 252)',
  car: 'rgb(182, 147, 254)',
  tank: 'rgb(126, 255, 219)',
  bridge: 'rgb(255, 211, 182)',
  harbor: 'rgb(245, 113, 112)',
}
const config = {
    apiUrl: 'https://sarms.tariky.cn',
    CATEGORIES_COLOR: CATEGORIES_COLOR
  };
  
  export default config;